// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCountriesDataView } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries, {
    loadCurrentCountriesParameter,
} from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const countriesDataView = getCountriesDataView(state, loadCurrentCountriesParameter);

    return {
        shouldLoadCountries: !countriesDataView.value && !countriesDataView.isLoading,
    };
};

const mapDispatchToProps = {
    loadCurrentCountries,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface TECSubmitNewStyles {
    page?: MobiusPageProps;
}

const tecSubmitNewStyles: TECSubmitNewStyles = {};

const styles = tecSubmitNewStyles;

const TECSubmitNewPage = ({ id, shouldLoadCountries, loadCurrentCountries }: Props) => {
    useEffect(() => {
        if (shouldLoadCountries) {
            loadCurrentCountries();
        }
    }, []);

    return (
        <Page data-test-selector="tecSubmitNew" {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TECSubmitNewPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;
